import { Ref, ref } from "vue";
import { SessionQuestionnaireApiModel } from "../api-models";
import { useAxios } from "./api";

export type CmsQuestionnaireSlice =
  | "cms-session-slide-with-checklist"
  | "cms-session-slide-with-dropdown";

export interface SessionDetails {
  currentTeamId: string | undefined;
  sessionId: string;
  sessionRef: string | null;
}

export interface SessionQuestionnaireDetails extends SessionDetails {
  sliceType: CmsQuestionnaireSlice;
}

interface SessionQuestionnaireResponse {
  questionnaire: Ref<SessionQuestionnaireApiModel | null>;
  isLoaded: Ref<boolean>;
}

export function useSessionQuestionnaire(
  details: SessionQuestionnaireDetails,
): SessionQuestionnaireResponse {
  const isLoaded = ref(false);

  const { data: questionnaire, promise } = useAxios<SessionQuestionnaireApiModel>(
    `/api/sessionquestionnaire/?team=${details.currentTeamId}&sessionId=${details.sessionId}&sessionRef=${details.sessionRef}`,
  );

  promise.then(() => {
    isLoaded.value = true;
  });

  return { questionnaire, isLoaded };
}
